import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class TaskListService {
  private base_url = `${environment.API_URL}/offers/`;
  private single_url = `${environment.API_URL}/tasks/`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getTasks(planning_id: number = null) {
    var params = {};
    if (planning_id) {
      params["id"] = planning_id;
      return this.http
        .post(this.base_url + params["id"] + "/tasks", params, {
          headers: this.headers,
        })
        .map((res) => JSON.parse(JSON.stringify(res)));
    } else {
      //console.log('pas de planning');
      return this.http
        .get(this.single_url, { headers: this.headers })
        .map((res) => JSON.parse(JSON.stringify(res)));
    }
  }

  createTask(params: object) {
    //params["token"] = this.token;
    return this.http
      .post(this.base_url + params["id"] + "/task", params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
        } else {
          //console.log(response);
          this.toast.error(
            "Erreur lors de l'ajout de la Tâche.",
            false,
            "Tâche"
          );
        }
      });
  }

  updateTask(params: object) {
    //params["token"] = this.token;
    return this.http
      .patch(this.single_url + params["id"], params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Tâche Mise à jour.", false, "Tâche");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la Tâche",
            false,
            "Tâche"
          );
        }
      });
  }

  deleteTask(task_id) {
    return this.http
      .delete(`${this.single_url}${task_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Tâche Supprimée.", false, "Tâche");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de la Tâche.",
            false,
            "Tâche"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/task-list.service.ts